<template>
    <div class="result-detail">
        <a-breadcrumb separator=">">
            <a-breadcrumb-item>
                <router-link to="/query-service">
                    <img :src="require('@/assets/home/报告查询.svg')" style="margin: 0 4px 4px 0" />查询服务
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
                <router-link :to="{ name: this.$route.query?.lastRouteName }">{{ lastRouteName }}</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>委托详情</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="result-detail-body">
            <div class="detail-item">
                <div class="item-title">基本信息</div>
                <div class="item-content">
                    <custom-form :option="baseInfoOption" :fieldsValue="baseInfoValue" />
                </div>
            </div>

            <div class="detail-item">
                <div class="item-title">委托信息</div>
                <div class="item-content">
                    <custom-form :option="clientOption" :fieldsValue="clientValue" />
                    <custom-form :option="sampleOption" :fieldsValue="sampleValue" />
                    <custom-form :option="otherOption" :fieldsValue="otherValue" />
                </div>
            </div>

            <div class="detail-item">
                <div class="item-title">检测项目</div>
                <div class="item-content">
                    <custom-form :option="testOption" :fieldsValue="testValue" />
                </div>
            </div>

            <div class="detail-item">
                <div class="item-title">样品信息</div>
                <div class="item-content">
                    <a-table
                        :columns="columns"
                        :data-source="listData"
                        :scroll="{ x: 1200, y: 400 }"
                        :pagination="pagination"
                    >
                    </a-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import customForm from '../../../components/custom-form.vue';

export default {
    computed: {
        lastRouteName() {
            const name = this.$route.query?.lastRouteName;
            if (name) {
                return this.routeMapper[name];
            }
            return '';
        }
    },

    data() {
        const listData = [];
        for (let index = 0; index < 100; index++) {
            listData.push({
                key: index + 1,
                name: '测试',
                age: index + 1,
                address: '123'
            });
        }

        return {
            routeMapper: {
                entrustQuery: '委托查询',
                reportQuery: '报告查询'
            },

            columns: [
                { title: '合同编号', dataIndex: 'name', key: 'name' },
                { title: '样品备注', dataIndex: 'age', key: 'age' },
                { title: '其他技术指标', dataIndex: 'address', key: '1' },
                { title: '样品编号', dataIndex: 'address', key: '2' },
                { title: '商标', dataIndex: 'address', key: '3' },
                { title: '样品名称', dataIndex: 'address', key: '4' },
                { title: '产品类型', dataIndex: 'address', key: '5' },
                { title: '样品描述', dataIndex: 'address', key: '6' },
                { title: '存款位置', dataIndex: 'address', key: '7' },
                { title: '生产时间', dataIndex: 'address', key: '8' }
            ],

            listData,

            pagination: {
                total: listData.length,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal(total) {
                    return `总共${total}条`;
                },

                defaultCurrent: 1
            },

            baseInfoOption: {
                id: 'baseInfo',
                gutter: 0,
                readonly: true,
                fieldGroup: [
                    [
                        {
                            label: '委托状态',
                            field: 'name',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '委托单号',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '下单日期',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ]
                ]
            },

            baseInfoValue: {
                name: '待受理',
                phone: 'N1231',
                address: '2023-10-19 15:14:53'
            },

            clientOption: {
                id: 'client',
                title: '委托方信息',
                gutter: 0,
                readonly: true,
                fieldGroup: [
                    [
                        {
                            label: '委托人/单位',
                            field: 'name',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '电话(委托方)',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '传真(委托方)',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ],
                    [
                        {
                            label: '邮编(委托方)',
                            field: 'name',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '邮箱(委托方)',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '送样人',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ],
                    [
                        {
                            label: '委托日期',
                            field: 'name',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '地址',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '样品类型',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ],
                    [
                        {
                            label: '来样方式',
                            field: 'name',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ]
                ]
            },

            clientValue: {
                name: '待受理',
                phone: 'N1231',
                address: '2023-10-19 15:14:53'
            },

            sampleOption: {
                id: 'sample',
                gutter: 0,
                title: '样品信息',
                readonly: true,
                fieldGroup: [
                    [
                        {
                            label: '委托人/单位',
                            field: 'name',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '电话(委托方)',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '传真(委托方)',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ]
                ]
            },

            sampleValue: {
                name: '待受理',
                phone: 'N1231',
                address: '2023-10-19 15:14:53'
            },

            otherOption: {
                id: 'other',
                gutter: 0,
                title: '其他信息',
                readonly: true,
                fieldGroup: [
                    [
                        {
                            label: '付款方式',
                            field: 'name',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '余样处理方式',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '是否退还',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ],
                    [
                        {
                            label: '是否分包',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        },
                        {
                            label: '备注',
                            field: 'phone',
                            span: 8,
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 }
                        }
                    ]
                ]
            },

            otherValue: {
                name: '待受理',
                phone: 'N1231',
                address: '2023-10-19 15:14:53'
            },

            testOption: {
                id: 'other',
                gutter: 0,
                readonly: true,
                fieldGroup: [
                    [
                        {
                            label: '项目名称',
                            field: 'name',
                            span: 12,
                            labelCol: { span: 5 },
                            wrapperCol: { span: 19 }
                        }
                    ]
                ]
            },

            testValue: {
                name: '型式校验｜招标集中检验规约测试｜信息安全测试'
            }
        };
    },
    methods: {},
    components: { customForm }
};
</script>

<style lang="scss" scoped>
.result-detail {
    width: 1200px;
    margin: 0 auto;
    &-body {
        .detail-item {
            margin-bottom: 16px;
            background: #ffffff;
            box-shadow: 0px 2px 4px 0px rgba(13, 24, 41, 0.05);
            border-radius: 2px;

            .item-title {
                position: relative;
                opacity: 0.97;
                background: #deefff;
                border-radius: 2px 2px 0px 0px;
                height: 40px;
                line-height: 40px;
                padding-left: 24px;
                font-size: 14px;
                color: #333333;
                font-weight: 600;

                &::before {
                    content: '';
                    width: 3px;
                    height: 12px;
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #005299;
                }
            }

            .item-content {
                padding: 16px;

                :deep(.custom-form) {
                    margin-bottom: 16px;
                    background-color: #fbfcff;
                    .title {
                        height: 40px;
                        line-height: 40px;
                        padding-left: 16px;
                        border-bottom: 1px solid #e2e2e2;
                    }
                }
            }
        }
    }
}
</style>
